export default __webpack_public_path__ + "static/footer-ff0b5cb7f949d99640d5542cf9090630.png";